import { useTranslation } from 'react-i18next'

import { FieldCategoryGrid } from '@/components/layout/field-row'
import { TabCard } from '@/components/layout/tab-card'

import { PlaceFeatureGroupSection } from '../../flags/place-feature-group'
import { PlaceFeatureGroupedListSkeleton } from '../../flags/place-feature-grouped-list'
import { PlaceFeaturesView } from '../../place-details.types'
import { FEATURE_GROUPS, FEATURE_GROUPS_BY_SIZE } from './features-tab'

interface FeaturesTabSkeletonProps {
  isAdmin: boolean
  view?: PlaceFeaturesView
}

// Note: title, group headers and labels are real, only the values are skeletons
export const FeaturesTabSkeleton = ({
  isAdmin,
  view = PlaceFeaturesView.classic,
}: FeaturesTabSkeletonProps) => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.features.tab.title')}>
      {view === PlaceFeaturesView.grouped ? (
        <PlaceFeatureGroupedListSkeleton groups={FEATURE_GROUPS} />
      ) : (
        <FieldCategoryGrid layout="rows">
          {FEATURE_GROUPS_BY_SIZE.map((group) => (
            <PlaceFeatureGroupSection
              key={group}
              group={group}
              isAdmin={isAdmin}
              isEditing={false}
            />
          ))}
        </FieldCategoryGrid>
      )}
    </TabCard>
  )
}
